<template>
  <v-container fluid class="pa-5">
    <v-layout align-center justify-center my-2>
      <v-flex md9 class="headline">
        Flujo de bot
      </v-flex>
      <v-flex md3>
        <v-btn class="k-orange-linear white--text" block large @click="openDialog">
          Agregar plantilla Bot
        </v-btn>
      </v-flex>
    </v-layout>
    <data-table
      ref="botTemplatesDialog"
      url="bot_templates"
      :search="search"
      :filters="filters"
      @items-reload="botTemplates = $event">
      <template slot="content" v-for="(item, i) in botTemplates">
        <v-list-tile
          :key="`botTemplate-${item.id}`"
          @click="editTemplate(item)"
          avatar>
          <v-list-tile-avatar>
            <v-icon class="k-orange-linear-text" large>
              fas fa-robot
            </v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <strong>
                {{ item.name }}
              </strong>
            </v-list-tile-title>
            <v-list-tile-sub-title>
              {{ templateTypes[item.type] }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-spacer></v-spacer>
          <v-chip
            small
            :class="{'green': item.status === 'Activo', 'red': item.status === 'Inactivo', 'blue': item.status === 'Procesando'}"
            class="white--text">
            <v-icon class="pr-2 x-small-icon" v-if="item.status === 'Activo'">fas fa-check</v-icon>
            <v-icon class="pr-2 x-small-icon" v-if="item.status === 'Inactivo'">fas fa-times</v-icon>
            {{ item.status }}
          </v-chip>
          <v-list-tile-action>
            <v-menu bottom offset-y @click.native.stop>
              <v-btn slot="activator" color="grey darken-2" small flat fab>
                <v-icon>fas fa-ellipsis-v</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile @click="changeStatus(item)" :disabled="item.status === 'Procesando'">
                  <v-list-tile-title>
                    {{ item.status === 'Activo' ? 'Desactivar' : 'Activar' }}
                  </v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="editTemplate(item)" :disabled="item.status === 'Procesando'">
                  <v-list-tile-title>Editar</v-list-tile-title>
                </v-list-tile>
                <v-list-tile @click="testTemplate(item)" :disabled="item.status === 'Procesando'">
                  <v-list-tile-title>Probar</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-list-tile-action>
        </v-list-tile>
        <v-divider
          v-if="i !== botTemplates.length - 1"
          :key="`divider${i}`"/>
      </template>
    </data-table>
    <bot-dialog
      :show="botDialog"
      :title="dialogTitle"
      @save="save"
      :data="botTemplate"
      :show-types="!editing"
      @close="botDialog = false"/>
    <change-status
      :show="changeStatusDialog"
      :bot-template="botTemplate"
      @updated="botTemplateUpdated"
      @close="changeStatusDialog = false"/>
   <test-template-dialog
      :show="testTemplateDialog"
      :template-id="testTemplateId"
      :channel="4"
      @close="testTemplateDialog = false" />
  </v-container>
</template>

<script>
import EventBus from '@/event-bus';
import DataTable from '@/components/global/DataTable2';
import ChangeStatus from '@/components/bot_v4/ChangeStatus';
import BotDialog from '@/components/bot_v4/BotDialog';
import TestTemplateDialog from '@/components/Templates/TestDialog';
import _ from 'lodash';

export default {
  components: {
    DataTable,
    BotDialog,
    ChangeStatus,
    TestTemplateDialog,
  },
  data() {
    return {
      botDialog: false,
      changeStatusDialog: false,
      testTemplateDialog: false,
      testTemplateId: 0,
      botTemplate: {},
      search: '',
      filters: {
        status: '',
      },
      botTemplates: [],
      states: [
        {
          text: 'Estatus',
          value: '',
        },
        {
          text: 'Activo',
          value: 'Activo',
        },
        {
          text: 'Inactivo',
          value: 'Inactivo',
        },
      ],
      templateTypes: {
        'colly': 'Agente AI',
        'payment_promise': 'Compromiso',
        'sale': 'Venta',
        'no_commitment': 'Sin compromiso',
        'customer_confirmation': 'Confirmacion de cliente',
        'payment_promise_basic': 'Compromiso (Basico)',
        'sale_basic': 'Venta (Basico)',
        'no_commitment_basic': 'Sin compromiso (Basico)',
        'customer_confirmation_basic': 'Confirmacion de cliente (Basico)',
        'payment_promise_basic_mail': 'Compromiso con mail (Basico)',
      },
    };
  },
  computed: {
    dialogTitle() {
      if (this.editing) {
        return 'Editar plantilla de bot';
      }

      return 'Crear plantilla de bot';
    },
    editing() {
      return Object.keys(this.botTemplate).length > 0;
    },
  },
  methods: {
    openDialog() {
      this.botTemplate = {};
      this.botDialog = true;
    },
    editTemplate(botTemplate) {
      if (botTemplate.type === 'colly') {
        this.botTemplate = botTemplate;
        this.botDialog = true;
        return;
      }

      if (botTemplate.status !== 'Procesando') {
        return this.$router.push(`/bot_v4/detail/${botTemplate.id}`);
      }
      EventBus.$emit('modal', 'Esta plantilla aun no se ha procesado.');
    },
    testTemplate(template) {
      this.testTemplateId = template.id;
      this.testTemplateDialog = true;
    },
    changeStatus(item) {
      this.botTemplate = {
        ...item,
      };
      this.changeStatusDialog = true;
    },
    botTemplateUpdated(botTemplate) {
      const index = this.botTemplates.findIndex(item => item.id === botTemplate.id);
      this.$set(this.botTemplates, index, botTemplate);
      this.botDialog = false;
    },
    async save(form) {
      if (this.editing) {
        return this.axios.patch(`bot_templates/${this.botTemplate.id}`, _.omit(form, ['type']))
        .then(({ data }) => this.botTemplateUpdated(data));
      }

      const data = await this.axios.post('bot_templates', form)
      .then(({ data }) => data)
      .catch((err) => {
        console.error('Error creando plantilla', err);
        return undefined;
      });

      if (!data) {
        EventBus.$emit('error', 'Ocurrio un error, intente nuevamente');
        return;
      }

      if (data.type === 'colly') {
        this.botTemplates.push(data);
        this.botDialog = false;
        return;
      }

      return this.$router.push(`bot_v4/detail/${data.id}`);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/bot_v4/Index.vue